// src/shared/catalog.js
//
// Runtime lookup into the line-item catalog — billing shape and payment-plan
// eligibility per pricing rowId, as classified by the team (billing review
// sheet, ingested via tools/ingest-billing.js which regenerates catalog.json
// here; never hand-edit that file).
//
// Used by shared/order.js on BOTH sides (server freezes orders, sign page
// previews them), so like the rest of src/shared it stays CommonJS and
// dependency-free. The bundled JSON deliberately carries no prices and no
// SKU/QuickBooks/license mappings — those stay server-side in tools/catalog.json.
//
// SKU codes are intentionally unassigned so far — the team hasn't labeled them.
// When that happens they'll be added to the sheet and re-ingested; nothing here
// invents identifiers in the meantime.
const catalog = require('./catalog.json');

const CATALOG_VERSION = `${catalog.version}:${catalog.classifiedAt}`;

// -> { billing: 'one_time'|'annual'|'monthly'|null, planOk: bool, keep: bool } | null
function catalogEntry(rowId) {
  if (!rowId) return null;
  return catalog.byRowId[rowId] || null;
}

// Billing shape for a row, 'unclassified' when the catalog doesn't know it —
// e.g. rows in old frozen snapshots that were later reclassified as terms, or
// products added after the last billing review.
function billingFor(rowId) {
  const e = catalogEntry(rowId);
  return (e && e.billing) || 'unclassified';
}

function planEligible(rowId) {
  const e = catalogEntry(rowId);
  return !!(e && e.planOk);
}

module.exports = { catalogEntry, billingFor, planEligible, CATALOG_VERSION };
